module.exports = __webpack_public_path__ + "static/Add-YouTube-Video-3-e1403554518516-3c5601fb04e9b23a4da11e8784ff207c.jpg";